/** Bounds are YYYY-MM-DD; a missing bound means open-ended. */
export function coversDate(period, date) {
    if (period.validFrom && date < period.validFrom)
        return false;
    if (period.validTo && date > period.validTo)
        return false;
    return true;
}
